import { ReactElement } from 'react';
import { IDashboardCompetitionConversion } from '.';
import { NavLink } from 'react-router-dom';
import { useComponentLevelAccessCheck } from '../../../../authGuard/hooks/useComponentLevelAccessCheck';

export const CompetitionConversion = (props: IDashboardCompetitionConversion): ReactElement => {
	const { id } = props;
	const checkPermissions = useComponentLevelAccessCheck('dashboard-competition-conversion');

	if (!checkPermissions) {
		return <></>;
	}

	return (
		<section key={id} className="competition-conversion-card">
			<div className="container">
				<NavLink
					to="/competition-conversion"
					aria-label="conversion recommender link"
					className="conversion-card-details"
				>
					<span className="icon-competition"> </span>
					<p>Competition Conversion Recommender</p>
					<span className="icon-arrow-right-circle"> </span>
				</NavLink>
			</div>
		</section>
	);
};
